import { PayrollAuditPage } from "../components/payroll/PayrollAuditPage.js";

export const PayrollBusinessAuditPage = ({
  embedded = false,
}: {
  embedded?: boolean;
}) => <PayrollAuditPage level="business" embedded={embedded} />;
